import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as styles from "./Accordion.module.scss";

const ToggleTemplate = ({ isActive, children, variant }) => (
	<div
		className={classNames(
			styles[`${variant}ToggleContainer`],
			isActive
				? styles[`${variant}ToggleContainerActive`]
				: styles[`${variant}ToggleContainerInactive`]
		)}>
		<span className={styles.accordionLabel}>{children}</span>
		<span className={styles.accordionChevron} />
	</div>
);

ToggleTemplate.propTypes = {
	isActive: PropTypes.bool,
	children: PropTypes.node,
	variant: PropTypes.string,
};

ToggleTemplate.defaultProps = {
	isActive: false,
	children: undefined,
	variant: "",
};

export default ToggleTemplate;
export { ToggleTemplate };
